import { useEffect, useState } from 'react';

export default function Hero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="hero" className="relative md:min-h-screen md:h-auto flex flex-col overflow-hidden" style={{ paddingTop: 0 }}>

      {/* ── z-0: Background image ── */}
      {/* Desktop: absolute fill */}
      <div className="hidden md:block absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/f07df38d1a99d5dc0dc212d8a92889a1.jpeg"
          alt="Recepção Escritório Jocimar Tadioto Advocacia Campo Grande MS"
          className="w-full h-full object-cover"
          style={{ objectPosition: 'center 30%' }}
        />
      </div>
      {/* Mobile: imagem ocupa 100% da viewport menos a navbar (110px) */}
      <div
        className="block md:hidden w-full"
        style={{ marginTop: '110px', height: 'calc(100vh - 110px)' }}
      >
        <img
          src="https://storage.readdy-site.link/project_files/da00dccb-6f2b-4895-83f6-06a68d0a526a/e96a40b7-c054-4715-87eb-8ab7ba2bcca4_ChatGPT-Image-27-de-abr.-de-2026-18_03_23.png?v=2d9651f4da8653d3f60a18b9840edc0e"
          alt="Recepção Jocimar Tadioto Sociedade de Advocacia"
          className="w-full h-full object-cover"
          style={{ objectPosition: 'center center' }}
        />
      </div>

      {/* ── z-10: Gradient overlays ── */}
      {/* Desktop */}
      <div className="hidden md:block absolute inset-0 z-10 bg-gradient-to-b from-black/75 via-black/55 to-black/15 pointer-events-none"></div>
      <div className="hidden md:block absolute inset-0 z-10 bg-gradient-to-r from-black/25 via-transparent to-black/25 pointer-events-none"></div>
      {/* Mobile overlay for text readability */}
      <div className="block md:hidden absolute z-10 bg-black/60 pointer-events-none" style={{ top: '110px', height: 'calc(100vh - 110px)', left: 0, right: 0 }}></div>

      {/* ── z-20: Main content (H1, subtitle, CTAs) ── */}
      <div className="flex z-20 flex-col items-center justify-start md:justify-start px-4 md:px-8 pt-10 md:pt-44 pb-8 md:pb-8 h-full md:h-auto md:relative md:flex-1 absolute" style={{ top: '110px', height: 'calc(100vh - 110px)', left: 0, right: 0 }}>
        <div
          className={`flex flex-col items-center text-center transition-all duration-1000 ease-out ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Eyebrow label */}
          <div className="flex items-center gap-3 mb-[1.375rem]">
            <div className="h-px w-[1.65rem] bg-[#C8B07A]"></div>
            <span
              className="text-[#C8B07A] text-[11px] font-semibold tracking-[0.4em] uppercase"
              style={{ textShadow: '0 1px 8px rgba(0,0,0,0.8)' }}
            >
              Campo Grande · MS
            </span>
            <div className="h-px w-[1.65rem] bg-[#C8B07A]"></div>
          </div>

          {/* Headline */}
          <h1
            className="text-[1.55rem] md:text-[2.86rem] font-bold text-white leading-tight mb-3 md:mb-[1.1rem] font-display"
            style={{ textShadow: '0 2px 20px rgba(0,0,0,0.8)' }}
          >
            Advocacia com{' '}
            <span className="text-[#C8B07A]">ética e resultados</span>
          </h1>

          {/* Supporting text */}
          <p
            className="text-[0.82rem] md:text-[1.1rem] text-white/85 mb-5 md:mb-[2.2rem] font-light leading-relaxed px-2 md:px-0"
            style={{ textShadow: '0 1px 12px rgba(0,0,0,0.9)' }}
          >
            Soluções jurídicas eficientes em diversas áreas do Direito.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-[0.825rem] w-full sm:w-auto">
            <a
              href="https://wa.me/5567999210516"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#C8B07A] hover:bg-[#D6C18F] text-[#1F2A44] px-6 md:px-[1.925rem] py-3 md:py-[0.825rem] rounded-md font-bold text-[0.875rem] md:text-[0.935rem] transition-all duration-300 cursor-pointer whitespace-nowrap hover:scale-105 w-full sm:w-auto"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-base"></i>
              </span>
              Falar com um Advogado
            </a>

            <button
              onClick={() => document.getElementById('areas')?.scrollIntoView({ behavior: 'smooth' })}
              className="inline-flex items-center justify-center gap-2 border border-white/30 hover:border-[#C8B07A] text-white/80 hover:text-[#C8B07A] px-6 md:px-[1.925rem] py-3 md:py-[0.825rem] rounded-md font-semibold text-[0.875rem] md:text-[0.935rem] transition-all duration-300 cursor-pointer whitespace-nowrap backdrop-blur-sm w-full sm:w-auto"
            >
              Áreas de Atuação
            </button>
          </div>
        </div>
      </div>

      {/* ── z-15: Spacer that pushes name to bottom (desktop only) ── */}
      <div className="hidden md:block relative z-15 flex-1"></div>

      {/* ── z-20: Scroll cue (desktop only) ── */}
      <div
        className={`hidden md:flex absolute bottom-6 right-8 md:right-[3.85rem] lg:right-[5.5rem] z-20 flex-col items-center gap-2 transition-all duration-1000 delay-700 ${
          visible ? 'opacity-40' : 'opacity-0'
        }`}
      >
        <span className="text-white text-[9px] tracking-[0.3em] uppercase rotate-90 mb-2">Scroll</span>
        <div className="w-px h-10 bg-white/40 animate-pulse"></div>
      </div>
    </section>
  );
}
